import React from 'react'
import HeroBanner from './Hero'
import Features from './features'

const Main = () => {
  return (
    <div>
        <HeroBanner />
        <Features />
    </div>
  )
}

export default Main